import { useMemo } from "react";
import { useLiveQuotes } from "@/context/LiveMarketContext";

// Many symbols → { BTC: { price, prev, at, change24, state }, ... } from the app-wide market feed.
// `symbols` may be strings or {symbol, id} objects (id enables the CoinGecko fallback for non-Coinbase coins).
export function useLivePrices(symbols = []) {
  const items = useMemo(() => symbols.filter(Boolean).map((s) => (typeof s === "string" ? { symbol: s } : s)), [symbols]);
  const { quotes, feed } = useLiveQuotes(items);
  return Object.assign(quotes, { __source: feed.source, __feed: feed });
}
